import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { computed } from "@vue/composition-api";
export const useAdditionalIncomeFieldBindings = options => {
  const {
    bindApplication,
    makeFieldPathReactive
  } = useBindApplication();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const currentIncomePath = computed(() => {
    return currentApplicantPath.value + "[other-income]" + `[${options.additionalIncomeIndex.value}]`;
  });
  const additionalIncomeAmount = bindApplication(makeFieldPathReactive(currentIncomePath, "[amount]"), 0);
  const additionalIncomeDescription = bindApplication(makeFieldPathReactive(currentIncomePath, "[description]"), "");
  const additionalIncomeIncomePeriod = bindApplication(makeFieldPathReactive(currentIncomePath, "[income-period]"), "");
  const additionalIncomeType = bindApplication(makeFieldPathReactive(currentIncomePath, "[type]"), "");
  return {
    additionalIncomeAmount,
    additionalIncomeDescription,
    additionalIncomeIncomePeriod,
    additionalIncomeType
  };
};